import LateralMenuElement from "./lateral-menu-element/LateralMenuElement";
import { APP_VERSION } from "@/lib/version";

type section = "inspections" | "checklist";

const appSections = ["inspections", "checklist"];

const LateralMenu = () => {
  return (
    <div className="flex flex-col justify-between h-full bg-[#F4F4F4] min-w-[75px] border-r border-[#DDDDDD]">
      <div className="w-full flex flex-col justify-center py-5">
        {appSections.map((appSection, index) => (
          <LateralMenuElement
            key={`lateral-${appSection}`}
            section={appSection as section}
            index={index}
          />
        ))}
      </div>
      <div className="self-center py-4 text-xs text-gray-300">
        {APP_VERSION}
      </div>
    </div>
  );
};

export default LateralMenu;
